import CONTRATO_DIARIO_ACTIVIDADES_POR_FRENTE from '@/graphql/querys/administracion/contratos/contrato/diarioactividades/contratoDiarioActividadesPorFrente.gql';
import AGREGAR_CONTRATO_DIARIO_ACTIVIDAD from '@/graphql/mutations/administracion/contratos/contrato/diarioactividades/agregarContratoDiarioActividad.gql';
import ACTUALIZAR_CONTRATO_DIARIO_ACTIVIDAD from '@/graphql/mutations/administracion/contratos/contrato/diarioactividades/actualizarContratoDiarioActividad.gql';
import REMOVER_CONTRATO_DIARIO_ACTIVIDAD from '@/graphql/mutations/administracion/contratos/contrato/diarioactividades/removerContratoDiarioActividad.gql';

export default {
  computed: {
    mixGetContratoFrentes() {
      if (!this.contratoFrentes) return [];
      return this.contratoFrentes.slice().sort((a, b) => a.orden - b.orden);
    },
  },
  methods: {
    async mixSubirImagenes(imagenes) {
      if (!imagenes) return [];
      const formData = new FormData();
      [...imagenes].forEach((img) => formData.append('imagenes', img));
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const { publicKeys } = await this.axios
        .post(`${this.$urlFileServer}/multiples-imagenes`, formData, options)
        .then((res) => ({ publicKeys: res.data }))
        .catch((err) => ({ err }));
      if (!publicKeys) return [];
      return publicKeys;
    },

    async mixAgregarContratoActividad() {
      // Nueva actividad
      const { actividad } = this;
      this.mixEsCargando();
      this.enviandoFormulario = true;

      // Subir imagenes
      if (actividad.imagenes.length > 0) {
        const imagenes = await this.mixSubirImagenes(actividad.imagenes);

        // convertir array a imagens
        actividad.imagenes = JSON.stringify(imagenes);
      } else {
        actividad.imagenes = JSON.stringify([]);
      }

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_DIARIO_ACTIVIDAD,
          variables: {
            actividad,
          },
          update: (store, { data: { agregarContratoDiarioActividad } }) => {
            const query = {
              query: CONTRATO_DIARIO_ACTIVIDADES_POR_FRENTE,
              variables: {
                idContratoFrente: this.idFrente,
                pagina: 1,
                numeroRegistros: 10,
              },
            };
            const { contratoDiarioActividadesPorFrente } = store.readQuery(query);
            const contratoDiarioActividadesPorFrenteCopia = contratoDiarioActividadesPorFrente
              .slice();
            contratoDiarioActividadesPorFrenteCopia.push(agregarContratoDiarioActividad);
            store.writeQuery({
              ...query,
              data: {
                contratoDiarioActividadesPorFrente: contratoDiarioActividadesPorFrenteCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarContratoActividad() {
      const { actividad } = this;
      this.mixEsCargando();
      this.enviandoFormulario = true;
      // Subir imagenes
      if (actividad.imagenes.length > 0) {
        const imagenesAnteriores = actividad.imagenes.filter((imagen) => typeof (imagen) === 'string');
        const imagenesNuevas = actividad.imagenes
          .filter((imagen) => typeof (imagen) === 'object');
        if (imagenesNuevas.length > 0) {
          // Subir las imagenes
          const imagenes = await this.mixSubirImagenes(imagenesNuevas);
          // Si se subieron las imagenes
          if (imagenes) {
            // se agregan las imagenes nuevas a las anteriores .
            const imagenesTodas = [...imagenesAnteriores, ...imagenes];
            actividad.imagenes = [...imagenesTodas];
          } else {
            // Si no se subieron imagenes nuevas se conseran solo las anteriores.
            actividad.imagenes = [...imagenesAnteriores];
          }
        }
      }
      actividad.imagenes = JSON.stringify(actividad.imagenes);
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_DIARIO_ACTIVIDAD,
          variables: {
            id: this.actividadContratoEditar.id,
            actividad: this.actividad,
          },
          update: (store, { data: { actualizarContratoDiarioActividad } }) => {
            const query = {
              query: CONTRATO_DIARIO_ACTIVIDADES_POR_FRENTE,
              variables: {
                idContratoFrente: this.actividadContratoEditar.idContratoFrente,
                pagina: 1,
                numeroRegistros: 10,
              },
            };
            const data = store.readQuery(query);
            const { contratoDiarioActividadesPorFrente } = data;
            const index = contratoDiarioActividadesPorFrente
              .findIndex((contratoActividad) => contratoActividad.id
              === actualizarContratoDiarioActividad.id);
            if (index !== -1) {
              contratoDiarioActividadesPorFrente
                .splice(index, 1, actualizarContratoDiarioActividad);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarContratoActividad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_DIARIO_ACTIVIDAD,
        variables: {
          id: this.contratoActividadEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_DIARIO_ACTIVIDADES_POR_FRENTE,
            variables: {
              idContratoFrente: this.contratoActividadEliminar.idContratoFrente,
              pagina: 1,
              numeroRegistros: 10,
            },
          };
          const data = store.readQuery(query);
          const { contratoDiarioActividadesPorFrente } = data;
          const index = contratoDiarioActividadesPorFrente
            .findIndex((actividad) => actividad.id === this.contratoActividadEliminar.id);
          if (index !== -1) {
            contratoDiarioActividadesPorFrente.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
